import { useState } from 'react';
import { AddressModel, AddressRequestModel, NewPropertyModel } from 'src/api/models';
import { useModal } from 'src/hooks/useModal';
import { useCheckCoverageMutation } from '../queries';

export function useCheckCoverage(shouldHandleModal = true) {
  const [isNotThereYetModalOpen, openNotThereYetModal, closeNotThereYetModal] = useModal();
  const [property, setProperty] = useState<NewPropertyModel>();
  const { isCheckCoverageLoading, checkCoverage: _checkCoverage } = useCheckCoverageMutation();

  async function checkCoverage(addressList: AddressModel[]) {
    let coverageList;
    try {
      coverageList = await _checkCoverage(addressList);
    } catch (e) {
      // THROW AGAIN?
      console.error(e);
      return;
    }

    const notInCoverage = coverageList.find((coverageItem) => !coverageItem.inCoverageArea);

    if (notInCoverage) {
      const address = notInCoverage.address as AddressRequestModel;
      const _property = { address, units: [{}] };

      if (address?.unitNumber) {
        _property.units = [{ unitNumber: address.unitNumber }];
      }

      if (shouldHandleModal) openNotThereYetModal();

      setProperty(_property);

      return false;
    }

    setProperty(undefined);

    return true;
  }

  return { isNotThereYetModalOpen, closeNotThereYetModal, isCheckCoverageLoading, checkCoverage, property };
}
